module.exports = __webpack_public_path__ + "static/media/fly0134.6b0823f7.webp";